import { Mutex } from 'async-mutex';

export class PromiseQueue {
  private queue: (() => Promise<unknown>)[] = [];
  private lock: Mutex = new Mutex();
  private halted = false;
  private tail: Promise<void> = Promise.resolve();

  add(promise: () => Promise<unknown>) {
    this.queue.push(promise);
    // Jobs run in FIFO order, so the settlement of the one enqueued last is
    // the settlement of everything enqueued so far
    this.tail = this.run().catch(() => undefined);
  }

  halt() {
    this.halted = true;
  }
  size() {
    return this.queue.length;
  }

  /**
   * Resolves once every promise enqueued so far has settled — immediately if
   * the queue is idle.
   */
  waitForIdle(): Promise<void> {
    return this.tail;
  }

  private run(): Promise<void> {
    return this.lock.runExclusive(async () => {
      const promise = this.queue.shift()!;
      if (this.halted) {
        return;
      }
      await promise();
    });
  }
}
